// src/components/AppLayout.js

import React from 'react';
import LeftPanel from './LeftPanel/LeftPanel';
import RightPanel from './RightPanel/RightPanel';
import useAppStore from '../contexts/useAppStore';

const AppLayout = () => {
  const isSidebarOpen = useAppStore((state) => state.isSidebarOpen);

  return (
    <div className="flex h-screen">
      {/* Sidebar Container with Transition */}
      <div
        className={`transition-all duration-300 ease-in-out ${
          isSidebarOpen ? 'w-48' : 'w-0'
        } flex-shrink-0 overflow-hidden`}
      >
        <LeftPanel />
      </div>

      {/* Main Content */}
      <div className="flex-grow">
        <RightPanel />
      </div>
    </div>
  );
};

export default AppLayout;
